import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerOverlay,
  Flex,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { SelectionCriterionDto } from "../../../../../autogen/bff-api";
import {
  QualificationRequirementFields,
  type QualificationFormValues,
} from "../../../../../common/library/fields/QualificationRequirementFields";
import { RequirementDialogHeader } from "../../../../../common/components/RequirementDialogHeader";

// t('Add requirement') t('Edit requirement') t('Cancel') t('Save')

export type { QualificationFormValues };

interface Props {
  isOpen: boolean;
  isSaving: boolean;
  mode: "add" | "edit";
  defaultValues?: QualificationFormValues;
  onSubmit: (values: SelectionCriterionDto) => Promise<void>;
  onClose: () => void;
}

const FORM_ID = "qualification-requirement-drawer-form";

export const QualificationRequirementDrawer = ({
  isOpen,
  isSaving,
  mode,
  defaultValues,
  onSubmit,
  onClose,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
      <DrawerOverlay />
      <DrawerContent>
        <RequirementDialogHeader title={t(mode === "edit" ? "Edit requirement" : "Add requirement")} />

        <DrawerBody>
          <QualificationRequirementFields formId={FORM_ID} defaultValues={defaultValues} onSubmit={onSubmit} />
        </DrawerBody>

        <DrawerFooter borderTopWidth="1px" borderColor="smBorder">
          <Flex gap="3">
            <Button variant="outline" onClick={onClose}>
              {t("Cancel")}
            </Button>
            <Button type="submit" form={FORM_ID} colorScheme="teal" isLoading={isSaving}>
              {t("Save")}
            </Button>
          </Flex>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
